import {
  mean, ceil, isEmpty, isNumber,
} from 'lodash/fp';

export const getToCommas = (num) => {
  if (!num) {
    return 0;
  }

  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const getRatio = (num, total) => {
  if (total === 0 || !isNumber(total)) {
    return 0;
  }

  return ceil((num / total) * 100);
};


export const getMean = (data) => {
  if (isEmpty(data)) {
    return 0;
  }

  return ceil(mean(data));
};
